const words = ['TRIAL FESTA', 'KUMAMOTO', 'FOOD STALL', 'KITCHEN CAR', 'HANDMADE', 'LOCAL'];

export default function Ticker() {
  return (
    <div className="overflow-hidden bg-accent-500 py-2.5 md:py-3">
      <div className="animate-marquee flex w-max items-center whitespace-nowrap">
        {[0, 1].map((loop) => (
          <div key={loop} className="flex items-center">
            {words.map((word) => (
              <span key={`${loop}-${word}`} className="flex items-center">
                <span className="px-5 text-[10.5px] en-label text-foreground-950 md:px-7 md:text-[12px]">{word}</span>
                <span className="h-1 w-1 rounded-full bg-foreground-950/60" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}